import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import AddCreditPaygoForm from "../../../features/wallet/components/wallets/AddCreditPaygoForm/AddCreditPaygoForm";



export const ADD_CREDIT_MODAL_ID = "add-credit-modal";

export default function AddCreditPage({onSuccess}: {onSuccess?: () => void}) {
  return <div>
    <AddCreditPaygoForm onSuccess={onSuccess} />

  </div>;
}

export const AddCreditDrawer = ({
  modalId,
 
}: {
  modalId?: string;
  children?: React.ReactNode;
}) => {
  const modalIdFound = modalId || ADD_CREDIT_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue([modalIdFound]);
  };

  const onSucces = () => {
    onClose();
  };

  return (
    <ModalDrawer
      urlParamName={modalIdFound}
      title={"Ajouter du Crédit"}
      onClose={onClose}
    >
         <AddCreditPage onSuccess={onSucces}  />
    </ModalDrawer>
  );
};
